import * as Sentry from '@sentry/browser'; // eslint-disable-line import/no-namespace
import {scrubUrlQueryParams} from 'util/urlUtils';
import appConfig from '../appConfig';

const SENSITIVE_APP_URL_QUERY_PARAMS = ['t'];

if (appConfig.sentryDsn) {
  Sentry.init({
    dsn: appConfig.sentryDsn,
    environment: appConfig.appEnvironment,
    release: appConfig.appBuildId,
    allowUrls: [/ezcater\.com/],
    beforeSend: event => {
      const isAppUrl = !!event.request?.url?.includes(window.location.origin);

      if (event.request?.url && isAppUrl) {
        const url = new URL(event.request.url);
        // eslint-disable-next-line no-param-reassign
        event.request.url = scrubUrlQueryParams(url, SENSITIVE_APP_URL_QUERY_PARAMS).toString();
      }

      return event;
    },
  });
}
